<template>
  <div v-loading="loading">
    <header-img :list="list"></header-img>
    <div class="main-content">
      <div class="top-title">账户管理</div>
      <div class="container">
        <el-form ref="form" :rules="dynamicRules" :model="formData" label-width="80px" label-position="left" size="mini">
          <div class="title">基本信息</div>
          <el-form-item label="账号">{{formData.phone}}</el-form-item>
          <el-form-item label="账号类型" prop="userType">
            <el-radio-group :disabled="!status" v-model="formData.userType" @change="handleRadioChange">
              <el-radio :label="2">企业</el-radio>
              <el-radio :label="1">个人</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-show="formData.userType===1">
            <el-form-item label="姓名" prop="name">
              <el-input clearable v-if="status" v-model.trim="formData.name" placeholder="请输入"></el-input>
              <div v-else>{{formData.name || '未填写'}}</div>
            </el-form-item>
            <el-form-item label="身份证号" prop="idCard">
              <el-input clearable v-if="status" v-model.trim="formData.idCard" placeholder="请输入" :maxlength="18"></el-input>
              <div v-else>{{formIdCard(formData.idCard) || '未填写'}}</div>
            </el-form-item>
            <el-form-item class="must" label="原件上传">
              <div v-if="status">
                <div class="sfz-upload">
                  <up-load class="sfz sfz-1 mr20" :isShowbutton="false" :isshwoList="true" :compress="true" @handleSuccess="validCard($event, 1)" v-model="uploadImg"></up-load>
                </div>
                <div class="tip">1. 5M以内，JPG/PNG格式的图片 2. 请勿提供虚假证件</div>
              </div>
              <div v-else>
                <!-- <div class="sfz-upload" v-if="formData.identityFront && status">
                  <img class="mr20" :src="formData.identityFront" />
                  <img :src="formData.identityBack" />
                </div>-->
                <div class="sfz-upload">
                  <img class="mr20" src="@/assets/sfz-1.png" />
                </div>
              </div>
            </el-form-item>
          </div>
          <div v-show="formData.userType===2">
            <el-form-item label="企业性质" prop="companyNature">
              <el-radio-group :disabled="!status" v-model="formData.companyNature ">
                <el-radio :label="1">国企</el-radio>
                <el-radio :label="2">私企</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="企业名称" prop="companyName">
              <el-input maxlength="64" clearable v-if="status" v-model.trim="formData.companyName" placeholder="请输入"></el-input>
              <div v-else>{{formData.companyName || '未填写'}}</div>
            </el-form-item>
            <el-form-item label="统一信用代码" prop="unifiedCreditCode">
              <el-input maxlength="64" clearable v-if="status" v-model.trim="formData.unifiedCreditCode" placeholder="请输入"></el-input>
              <div v-else>{{formData.unifiedCreditCode || '未填写'}}</div>
            </el-form-item>
            <div>
              <el-row v-if="status">
                <el-col :span="10" class="register-box">
                  <el-form-item label="注册地址" prop="adressCode">
                    <el-cascader clearable :options="regionData" @change="handleChange" v-model="formData.adressCode"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label-width="0" prop="registRegion" class="regist-region">
                    <el-input maxlength="64" clearable v-model.trim="formData.registRegion" placeholder="请输入地址"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="注册地址" v-else>{{formData.registAddress+formData.registRegion || '未填写'}}</el-form-item>
            </div>

            <el-form-item label="法人姓名" prop="name">
              <el-input clearable v-if="status" v-model.trim="formData.name" placeholder="请输入"></el-input>
              <div v-else>{{formData.name || '未填写'}}</div>
            </el-form-item>
            <el-form-item label="法人身份证号" prop="idCard">
              <el-input clearable v-if="status" v-model.trim="formData.idCard" placeholder="请输入"></el-input>
              <div v-else>{{formData.idCard || '未填写'}}</div>
            </el-form-item>
            <el-form-item class="must" label="法人证件上传">
              <div v-if="status">
                <div class="sfz-upload">
                  <up-load class="sfz sfz-1 mr20" :isShowbutton="false" :isshwoList="true" :compress="true" @handleSuccess="validCard($event, 1)" v-model="uploadImg"></up-load>
                </div>
                <div class="tip">1. 5M以内，JPG/PNG格式的图片 2. 请勿提供虚假证件</div>
              </div>
              <div v-else>
                <!-- <div class="sfz-upload" v-if="formData.identityFront && status">
                  <img class="mr20" :src="formData.identityFront" />
                  <img :src="formData.identityBack" />
                </div>-->
                <div class="sfz-upload">
                  <img class="mr20" src="@/assets/sfz-1.png" />
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="身份认证">
            <el-button v-if="status" @click="getFirshQRCode()">立即认证</el-button>
            <div v-else>{{formData.personVertification?'已认证':'未认证'}}</div>
          </el-form-item>
          <div class="title">银行信息</div>
          <el-form-item class="bank-list">
            <div class="bank-operate" v-show="status">
              <el-button @click="addBank">+ 新增</el-button>
              <el-button @click="subBank">- 删除</el-button>
            </div>
            <el-table :data="bankList" @selection-change="handleSelectionChange" style="width:100%">
              <el-table-column type="selection" width="50" align="center"></el-table-column>
              <el-table-column label="账户类型" width="190" align="center">
                <template slot-scope="scope">
                  <!--                  <el-radio-group v-if="status" v-model="scope.row.type" @change="changeTypeRadio(scope.row)">-->
                  <!--                    <el-radio :label="1">个人</el-radio>-->
                  <!--                    <el-radio :label="4">企业</el-radio>-->
                  <!--                  </el-radio-group>-->
                  <!--                  <div v-if="!status">{{scope.row.type==1?'个人':scope.row.type==4?'企业':''}}</div>-->
                  <div v-if="formData.userType===2">企业</div>
                  <div v-else>个人</div>
                </template>
              </el-table-column>
              <el-table-column label="户名" align="center">
                <template slot-scope="scope">
                  <el-input v-if="status" placeholder="请输入" v-model="scope.row.accountName"></el-input>
                  <div v-else>{{scope.row.accountName}}</div>
                </template>
              </el-table-column>
              <el-table-column label="开户银行" align="center">
                <template slot-scope="scope">
                  <el-input v-if="status" placeholder="请输入" v-model="scope.row.bankName"></el-input>
                  <div v-else>{{scope.row.bankName}}</div>
                </template>
              </el-table-column>
              <el-table-column label="账号类型" align="center" width="100">
                <template slot-scope="scope">
                  <el-select v-if="status" placeholder="请选择" v-model="scope.row.isPassbook" class="bank-type">
                    <el-option v-for="(item, index) in bankType" :key="index" :label="item.name" :value="item.val"></el-option>
                  </el-select>
                  <div v-else>{{scope.row.isPassbook == 1 ?'存折':scope.row.isPassbook == 2 ? '银行卡':'---'}}</div>
                </template>
              </el-table-column>
              <el-table-column label="银行账号" align="center">
                <template slot-scope="scope">
                  <el-input maxlength="19" v-if="status" placeholder="请输入" v-model.trim="scope.row.bankCard" @input="changeInput($event,scope.$index)"></el-input>
                  <div v-else>{{formBankNumber(scope.row.bankCard)}}</div>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <div class="footer-button mt20">
          <el-button @click="sumbitForm">{{status? '确定并提交' : '编辑'}}</el-button>
        </div>
        <el-dialog width="60%" title="FaceID身份验证" :visible.sync="innerVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
          <el-row style="text-align:center;">
            <vue-qr :text="QRcode" :size="300"></vue-qr>
            <p>请使用手机扫码验证</p>
          </el-row>
        </el-dialog>
        <!-- 认证弹窗 -->
        <Dialog :show="show" @dialogClose="show=false" :img="'success.png'" :content="'恭喜你，提交成功'" />
      </div>
    </div>
  </div>
</template>
<script>
  import {regionData,CodeToText,TextToCode} from 'element-china-area-data'
  import HeaderImg from '@/components/HeaderImg'
  import VueQr from 'vue-qr'
  import UpLoad from '@/components/Upload'
  import Dialog from '@/components/Dialog'
  import publicFunction from '@/utils/publicFunction'
  import { sessionStore } from '@/utils/data-management'
  import { stat } from 'fs'
  export default {
    components: {
      HeaderImg,
      VueQr,
      UpLoad,
      Dialog,
    },
    data() {
      return {
        regionData,
        bankType: [{ name: "银行卡", val: 2 }, { name: "存折",val: 1  }],
        list: [{ name: '首页', path: '/Home' }, { name: '账户管理' }],
        status: this.$route.query.status == 1 ? true : false, // false，查看；ture，编辑
        formData: {
          userType: null, //账号类型
          companyNature: null, //企业性质
          adressCode: [],
          name: '',
          idCard: '',
          identityFront: '',
          identityBack: '',
          accountName: '',
          bankName: '',
          bankCard: '',
        },
        rule1: {
          name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          idCard: [
            { required: true, message: '请输入身份证号', trigger: 'blur' },
          ],
          userType: [{ required: true, message: '请选择账号类型', trigger: 'change' }]
        },
        rule2: {
          name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          idCard: [
            { required: true, message: '请输入身份证号', trigger: 'blur' },
          ],
          userType: [{ required: true, message: '请选择账号类型', trigger: 'change' }],
          companyNature: [{ required: true, message: '请选择企业性质', trigger: 'change' }],
          companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
          unifiedCreditCode: [{ required: true, message: '请输入统一信用代码', trigger: 'blur' }],
          adressCode: [{ required: true, message: '请选择注册地址', trigger: 'change' }],
          registRegion: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        },
        user: {
          name: '',
          idCard: '',
        },
        adress: '', //省市区地址
        face: false,
        innerVisible: false, // 人脸二维码
        QRcode: '',
        timeoutKey: '',
        loading: false,
        show: false,
        bankList: [],
        bankSelect: [],
        uploadImg: '',
      }
    },
    computed: {
      // 动态切换验证规则
      dynamicRules() {
        return this.formData.userType ===  1 ? this.rule1: this.rule2;
      },
      personVertification() {
        if (this.$store.state.userInfo) {
          if (this.$store.state.userInfo.personVertification) return "已认证";
        }
        return "未认证";
      },
    },
    mounted() {
      this.getUserInfo()
      this.getBankList()
    },
    methods: {
      changeInput(value,index){
        this.$set(this.bankList[index],'bankCard',value.replace(/\D/g, ''))
      },
      handleRadioChange(val){
        this.$refs.form.clearValidate()
      },
      handleChange(value){
        if (value[1] != null && value[2] != null) {
          this.adress = CodeToText[value[0]]  + CodeToText[value[1]] + CodeToText[value[2]]
        }
      },
      changeTypeRadio(row){
        if (!this.status) return;
        if(row.type == 4){
          this.bankList.forEach((item) =>{
            if(item.id == row.id){
              row.isDefault = 0
            }
          })
        }
      },
      setDefault(row) {
        if (!this.status) return
        this.bankList.forEach((item) => {
          item.isDefault = 0
          if (item.id == row.id) {
            row.isDefault = 1
          }
        })
      },
      getUserInfo() {
        window.scrollTo(0, 0)
        this.$api.user.getUserInfo({}).then((res) => {
          if (res.code === 1000) {
            this.formData = res.data
            if(this.formData.registRegionProvince){
              this.$set(this.formData,'adressCode',[this.formData.registRegionProvince,this.formData.registRegionCity,this.formData.registRegionArea])
            }
            this.adress = res.data.registAddress
            this.user = {
              name: this.formData.name,
              idCard: this.formData.idCard || '',
            }
            if (this.formData.identityFront) {
              this.face = true
            }
            sessionStore.set('userInfo', res.data)
            this.$store.commit('SET_USER_INFO', res.data)
          }
        })
        // if (sessionStore.get('userInfo')) {
        //   this.formData = sessionStore.get('userInfo')
        //   if(this.formData.registRegionProvince){
        //     this.$set(this.formData,'adressCode',[this.formData.registRegionProvince,this.formData.registRegionCity,this.formData.registRegionArea])
        //   }
        //   this.user = {
        //     name: this.formData.name,
        //     idCard: this.formData.idCard || '',
        //   }
        //   if (this.formData.identityFront) {
        //     this.face = true
        //   }
        // }
      },
      getBankList() {
        this.$api.user.getMyCard({}).then((res) => {
          if (res.code == 1000) {
            this.bankList = res.data
          }
        })
      },
      // 校验身份证
      validCard(url, index) {
        const loading = this.$loading({
          lock: true,
          text: '身份证识别中',
          background: 'rgba(0, 0, 0, .05)',
        })
        this.face = false
        this.$api.user
          .getCardValid({ image: url })
          .then((res) => {
            loading.close()
            if (res.code == 1000) {
              if (!res.data.name) {
                this.uploadImg = ''
                // this.formData.identityFront = "";
                this.$message.error('请上传身份证正面照')
                return
              }
              this.user = {
                name: res.data.name,
                idCard: res.data.idNumber,
              }
            } else {
              this.uploadImg = ''
              // this.formData.identityFront = "";
            }
          })
          .catch((err) => {
            loading.close()
            this.uploadImg = ''
            // this.formData.identityFront = "";
          })
      },
      // 第一次人脸
      getFirshQRCode() {
        // if (!this.formData.identityFront || !this.formData.identityBack) {
        let img = this.uploadImg ? this.uploadImg : this.formData.identityFront
        if (!img) {
          return this.$message.error('请先上传身份证照进行识别')
        }
        if (
          this.formData.name != this.user.name ||
          this.formData.idCard != this.user.idCard
        ) {
          return this.$message.error('姓名或身份证号与身份证照不一致')
        }
        let data = {
          identityFront: img,
          // identityBack: this.formData.identityBack
        }
        this.loading = true
        this.$api.user
          .getFaceFirst(data)
          .then((res) => {
            if (res.code === 1000) {
              this.timeoutKey = res.data.callbackId
              this.QRcode = res.data.verifyFaceUrl
              this.innerVisible = true
              this.checkQRCode()
            } else {
              this.$message.error(res.message)
            }
            this.loading = false
          })
          .finally(() => {
            this.loading = false
          })
      },
      // 轮询人脸结果
      checkQRCode() {
        if (this.timeoutKey === '' && this.$route.name != 'AccountManagement') {
          return
        }
        let data = {
          callbackId: this.timeoutKey,
        }
        this.$api.user.checkQRCode(data).then((res) => {
          if (res.data.status == 1) {
            this.$message.success('FaceId验证成功')
            this.face = true
            this.innerVisible = false
          } else if (res.data.status == 0) {
            setTimeout(() => {
              this.checkQRCode()
            }, 5000)
          } else {
            this.$message.error('FaceId验证失败')
            this.innerVisible = false
          }
        })
      },
      formIdCard(card) {
        if (!card) return
        return card.replace(/(\w{8})\w*(\w{4})/, '$1******$2')
      },
      // 显示前4后4位银行卡号
      formBankNumber(bankNumber) {
        if (!bankNumber) return
        return `${bankNumber.substr(0, 4)}**********${bankNumber.substr(-4)}`
      },
      // 银行卡
      handleSelectionChange(val) {
        this.bankSelect = val
      },
      addBank() {
        if (!this.status) return
        let status = this.requiredBank()
        if (status) return
        let add = { accountName: '', bankName: '', bankCard: '', type: 1, isDefault: 0, isPassbook: 2 }
        this.bankList.push(add)
      },
      subBank() {
        if (!this.status) return
        if (this.bankSelect.length < 1) {
          return this.$message.error('请选择要删除的银行卡')
        }
        let ids = this.bankSelect.map((item) => JSON.stringify(item))
        let data = this.bankList.filter((item) => {
          let index = ids.indexOf(JSON.stringify(item))
          if (index != -1) {
            ids.splice(index, 1)
          } else {
            return item
          }
        })
        this.bankList = data
      },
      requiredBank() {
        let status = false
        let hash = {}
        this.bankList.map((item) => {
          if (status) return
          if (!item.accountName) {
            status = true
            this.$message.error('请填写银行卡户名')
            return
          }
          if (!item.bankName) {
            status = true
            this.$message.error('请填写银行卡开户银行')
            return
          }
          if (!item.bankCard) {
            status = true
            this.$message.error('请填写银行账户')
            return
          }
          if (hash[item.bankCard]) {
            status = true
            this.$message.error('不能输入两张一样的银行卡号')
            return
          } else {
            hash[item.bankCard] = true
          }
        })
        return status
      },
      sumbitForm() {

        if (!this.status) {
          // 进入编辑状态
          this.status = true
          window.scrollTo(0, 0)
        } else {
          this.$refs.form.validate((v) => {
            if (v) {
              // 提交
              let img = this.uploadImg
                ? this.uploadImg
                : this.formData.identityFront
              if (!publicFunction.isIdCard(this.formData.idCard)) {
                return this.$message.error('身份证号填写错误')
              }
              if (!img) {
                return this.$message.error('请上传身份证正面照')
              }
              if (!this.face) {
                return this.$message.error('请先进行身份认证')
              }
              if (
                this.formData.name != this.user.name ||
                this.formData.idCard != this.user.idCard
              ) {
                return this.$message.error('姓名或身份证号与身份证照不一致')
              }
              let status = this.requiredBank()
              if (status) return
              let data = {
                userType: this.formData.userType,
                name: this.formData.name,
                idCard: this.formData.idCard,
                identityFront: img,
                callbackId: this.timeoutKey,
                personBankCardRequestList: [],
              }
              if(this.formData.userType===2){
                data.companyNature = this.formData.companyNature
                data.companyName = this.formData.companyName
                data.unifiedCreditCode = this.formData.unifiedCreditCode
                data.registRegionProvince = this.formData.adressCode[0]
                data.registRegionCity = this.formData.adressCode[1]
                data.registRegionArea = this.formData.adressCode[2]
                data.registRegion = this.formData.registRegion
                data.registAddress = this.adress
              }else {
                data.companyNature = ''
                data.companyName = ''
                data.unifiedCreditCode = ''
                data.registRegionProvince = ''
                data.registRegionCity = ''
                data.registRegionArea = ''
                data.registRegion = ''
                data.registAddress = ''
              }
              data.personBankCardRequestList = this.bankList.map((item) => {
                let data = {
                  id: item.id,
                  bankCard: item.bankCard,
                  accountName: item.accountName,
                  bankName: item.bankName,
                  isDefault: item.isDefault,
                  type: this.formData.userType===2?4:1,
                  isPassbook: item.isPassbook,
                }
                return data
              })
              this.loading = true
              this.$api.user
                // .getPersonVaild(data)
                .getPersonValidResult(data)
                .then((res) => {
                  if (res.code === 1000) {
                    this.$api.user.getUserInfo({}).then((res) => {
                      if (res.code === 1000) {
                        sessionStore.set('userInfo', res.data)
                        this.$store.commit('SET_USER_INFO', res.data)
                        this.show = true
                        this.status = false
                        setTimeout(() => {
                          this.$goTo('Home')
                        }, 1500)
                      }
                    })
                  }
                })
                .finally(() => {
                  this.loading = false
                })
            } else {
              return this.$message.error('请完善信息')
            }
          })
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  /deep/.el-form-item__error{
    left: 60px;
  }
  /deep/.regist-region .el-form-item__error{
    left: 0;
  }
  .register-box{
    width: 39% !important;
  }
  .main-content {
    width: auto;
    max-width: 1200px;
    margin: auto;
    background: #fff;
    padding: 20px;
    padding-bottom: 50px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    .header {
      position: relative;
      bottom: 44px;
    }
  }
  .container {
    width: 1000px;
    margin: 0 auto;
  }

  .title {
    line-height: 54px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #394259;
    letter-spacing: 0;
    background: #f8f9fb;
    padding-left: 43px;
    margin-bottom: 22px;
  }
  .tip {
    font-size: 10px;
    color: #a8aaae;
    margin-left: 55px;
  }
  .status {
    font-size: 14px;
    font-weight: 400;
    margin-left: 100px;
  }
  .el-form {
    margin-left: 90px;
    .el-form-item {
      .el-input,
      .el-select {
        width: 300px;
        /deep/ input {
          height: 30px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(240, 240, 240, 1);
          padding: 9px 10px;
        }
      }
      .el-textarea {
        /deep/ textarea {
          border-radius: 2px;
          border: 1px solid rgba(240, 240, 240, 1);
        }
      }
      .sfz-upload {
        display: flex;
        .sfz /deep/ .info-container {
          width: 247px;
          height: 156px;
          background: url('../../assets/sfz-1.png') no-repeat;
          background-size: 100% 100%;
          border-width: 0;
          div {
            display: none;
          }
        }
        .sfz-2 /deep/ .info-container {
          background: url('../../assets/sfz-2.png') no-repeat;
          background-size: 100% 100%;
        }
        /deep/ img {
          width: 247px;
          height: 156px;
          border-width: 0;
        }
        /deep/ .el-link--inner {
          display: none;
        }
      }
      .bank-type {
        width: 80px;
      }
    }
    .bank-list {
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }
      /deep/ .el-input {
        width: 100%;
        text-align: center;
      }
    }
    .must /deep/ .el-form-item__label::before {
      content: '*';
      color: #f56c6c;
    }
    /deep/ .el-form-item__label {
      margin-left: 42px;
      margin-right: 18px;
      text-align-last: justify;
      text-align: justify;
      text-justify: distribute-all-lines;
      position: relative;
      white-space: pre;
    }
    /deep/ .el-form-item__label::before {
      position: absolute;
      left: -10px;
      display: none;
    }
  }
  .footer-button {
    text-align: center;
    button {
      width: 300px;
      height: 44px;
      border-radius: 2px;
      margin-left: 600px;
      border: none;
      color: #fff;
      background: linear-gradient(135deg, #22c686 0%, #148257 100%);
    }
  }
  .el-icon-success {
    color: green;
    margin-right: 5px;
  }
  .setBtn {
    color: #409eff;
    cursor: pointer;
  }
</style>
